import _debounce from 'lodash/debounce'
import _uniq from 'lodash/uniq'
import _flattenDeep from 'lodash/flattenDeep'
import { ref, computed } from '@vue/composition-api'
import { getCmPrograms } from '@/api'
import store from '@/store'
import effectiveDatesRangeLookup from '@/utils/effectiveDatesRangeLookup'

const programsStore = ref({})
const programGroupIds = ref([])
const isLoading = ref(false)

async function _fetchPrograms (params) {
  const ids = [ ...programGroupIds.value ]
  programGroupIds.value = []
  const programs = await getCmPrograms({ programGroupIds: _uniq(_flattenDeep(ids)), ...params, includePending: true })
  Object.assign(programsStore.value, programs)
  isLoading.value = false
  programGroupIds.value = []
  return programsStore
}
const _fetchProgramsDebounced = _debounce(_fetchPrograms, 150)

async function _fetchProgram ({ programGroupId, ...params }) {
  isLoading.value = true
  programGroupIds.value.push(programGroupId)
  return _fetchProgramsDebounced({ ...params })
}

export default function useSharedPrograms ({ school = store.getters.school } = {}) {
  const mergedProgramsStore = computed(() => ({
    ...store.state.curriculumPrograms.programs,
    ...programsStore.value,
  }))

  const getProgramByDatesRangeLookup = ({
    programGroupId,
    effectiveDatesRange,
    groupIdAttribute,
    useFetchRequisitesWithLatestRevision,
  }) => effectiveDatesRangeLookup({
    resources: mergedProgramsStore.value,
    groupIdAttribute: groupIdAttribute || 'programGroupId',
    effectiveDatesRange: effectiveDatesRange.value,
    groupIdValue: programGroupId.value,
    useFetchRequisitesWithLatestRevision,
  })

  return {
    programs: mergedProgramsStore,
    getProgramByDatesRangeLookup,
    fetchProgram: (params) => _fetchProgram({ school, ...params }),
    isLoading,
  }
}
